export default __webpack_public_path__ + "static/media/hkkba_logo.5b7e6b1d.png";